import styled from 'styled-components';

// @todo: ajustar responsividade
export const Container = styled.div`
  display: flex;
  flex: 1;
  margin: 12% 0 4% 15.625%;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1024px) {
    margin: 20% 0 0 0;
  }

  @media (max-width: 960px) {
    margin: 26% 0 0 0;
  }
`;

export const ButtonContainer = styled.div`
  max-width: 515px;
  margin-top: 42px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  & + div {
    margin-top: 42px;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
  }
  @media (max-width: 960px) {
    flex-direction: column;
    margin-bottom: 10%;
  }
`;

export const Paragraph = styled.p`
  font-size: 1.125rem;
  font-weight: 300;
  color: #6c677a;
  text-align: right;
  margin-right: 22px;

  @media (max-width: 1024px) {
    margin-bottom: 5%;
    font-size: 2.2rem;
  }

  @media (max-width: 960px) {
    margin-bottom: 5%;
    font-size: 1.2rem;
    margin-right: 0;
  }
`;

export const SnackbarContainer = styled.div`
  margin-top: 38.5px;
`;
